import { h } from '@atomify/jsx';
import { ButtonLoader } from '@atoms/button-loader';
import { BPDFunctionalSvg } from '@atoms/svg/svg';

export interface ButtonSquareInterface {
    variant?: string;
    classes?: string;
    hook?: string;
    attributes?: {};
    ariaLabel: string;
    svg?: string;
    onClick?: Function;
    url?: string;
    disabled?: boolean;
    hasLoading?: boolean;
    loadableModal?: string;
    children?: Element;
    element?: string;
    label?: string | Text;
}

const createClassName = (data: ButtonSquareInterface) => {
    return {
        ['c-button-square']: true,
        ...(data.variant && { [`button-square--${data.variant}`]: true }),
        ...(data.classes && { [data.classes]: true }),
    };
};

const createAttributes = (data: ButtonSquareInterface) => {
    return {
        ['aria-label']: data.ariaLabel,
        ...data.attributes,
        ...(data.url && { href: data.url }),
        ...(data.onClick && { onClick: data.onClick }),
        ...(data.disabled && { disabled: data.disabled }),
        ...(data.hook && { [`js-hook-${data.hook}`]: data.hook }),
        ...(data.loadableModal && { [`js-hook-loadable-modal`]: data.loadableModal }),
    };
};

const ButtonSquare = (data: ButtonSquareInterface) => {
    const className = createClassName(data);
    const attributes = createAttributes(data);

    const Tag = `${data.element || 'button'}`;

    return (
        <Tag className={className} {...attributes}>
            {data.svg && <BPDFunctionalSvg name={data.svg} />}
            {data.label && <span class="button-square__label">{data.label}</span>}
            {data.children && <span class="button-square__label">{data.children}</span>}
            {(data.hasLoading || data.loadableModal) && <ButtonLoader />}
        </Tag>
    );
};

const ButtonSquareA = ({ children, ...data }: ButtonSquareInterface) => {
    return (
        <ButtonSquare {...data} element="a">
            {children}
        </ButtonSquare>
    );
};

export { ButtonSquare, ButtonSquareA };
